import React, { Component } from 'react';
import { connect } from 'react-redux';
import { api } from 'api';
import { Link } from 'react-router-dom';
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import Swal from 'sweetalert2';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Pagination, PaginationItem, PaginationLink, Input, Badge, Row, Col, FormGroup, Label, Table, Card, CardBody } from 'reactstrap';
import "./roles-list.css";

class RolesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            loading: true,

            // Modal state
            modalOpen: false,
            selectedRole: null,
            roleUsers: [],
            usersLoading: false,
            usersPage: 1,
            usersTotal: 0,
            hasNextPage: false,
            hasPrevPage: false,
            selectedRoleId: null,

            // Filters
            search: '',
            filterStatus: 'all', // all, true, false

            // Header Search (Visual)
            headerSearch: '',
        };
    }

    componentDidMount() {
        this.fetchRoles();
    }

    fetchRoles = async () => {
        try {
            const response = await api.get('roles');
            this.setState({ roles: response.results || response, loading: false });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
        }
    };

    initializeDefaults = async (reset = false) => {
        if (reset) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: "Esto sobreescribirá TODOS los roles y permisos con la configuración por defecto del sistema. Cualquier cambio personalizado se perderá.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, resetear todo',
                cancelButtonText: 'Cancelar'
            });
            if (!result.isConfirmed) return;
        }

        try {
            await api.post('roles/initialize_defaults', { reset });
            this.fetchRoles();
            Swal.fire(
                'Completado',
                reset ? 'Roles reseteados a valores de fábrica.' : 'Roles faltantes inicializados.',
                'success'
            );
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Hubo un problema al inicializar los roles.', 'error');
        }
    };


    // User Modal Logic
    openUsersModal = async (role) => {

        const roleId = role.system_role
            ? (
                role.system_role.const_value ||
                role.system_role.id
            )
            : role.role;

        this.setState({
            modalOpen: true,
            selectedRole: role,
            selectedRoleId: roleId,
            usersPage: 1,
            roleUsers: [],
            search: '',
            filterStatus: 'all'
        }, () => {
            this.fetchRoleUsers(roleId, 1);
        });
    };


    closeModal = () => {
        this.setState({ modalOpen: false, selectedRole: null, roleUsers: [] });
    };

        fetchRoleUsers = async (roleId, page) => {
        this.setState({ usersLoading: true });

        const { search, filterStatus } = this.state;

        const params = { page };

        if (search) params.search = search;

        if (filterStatus !== 'all') {
            params.is_active = filterStatus;
        }

        try {
            const response = await api.get(
                `roles/by_role/${roleId}/users`,
                params
            );

            this.handleUsersResponse(response, page);

        } catch (error) {
            console.error("Error fetching users", error);

            this.setState({
                usersLoading: false
            });
        }
    };


    handleUsersResponse = (response, page) => {
        let users = [];
        let total = 0;
        let hasNext = false;
        let hasPrev = false;

        if (response.results) {
            users = response.results;
            total = response.count;
            hasNext = !!response.next;
            hasPrev = !!response.previous;
        } else {
            users = response;
            total = users.length;
        }

        this.setState({
            roleUsers: users,
            usersTotal: total,
            usersLoading: false,
            hasNextPage: hasNext,
            hasPrevPage: hasPrev,
            usersPage: page
        });
    }

    changePage = (newPage) => {
        const { selectedRole } = this.state;
        if (selectedRole) {
            const { selectedRoleId } = this.state;

            this.fetchRoleUsers(selectedRoleId, newPage);
        }
    };

    handleFilterChange = (field, value) => {
        this.setState({ [field]: value, usersPage: 1 }, () => {
            const { selectedRole } = this.state;
            if (selectedRole) {
                const { selectedRoleId } = this.state;

                this.fetchRoleUsers(selectedRoleId, 1);
            }
        });
    };


    render() {
        const { roles, loading, modalOpen, selectedRole, roleUsers, usersLoading, usersPage, hasNextPage, hasPrevPage, usersTotal, search, filterStatus, headerSearch } = this.state;

        // Filter roles based on search
        const filteredRoles = roles.filter(role =>
            (role.name || role.role_display || '').toLowerCase().includes(headerSearch.toLowerCase()) ||
            String(role.role).toLowerCase().includes(headerSearch.toLowerCase())
        );

        return (
            <div className="container mt-4 pb-5">
                {/* Header */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                    <div>
                        <h2>Gestión de Roles y Permisos</h2>
                        <p className="text-muted mb-0">Configuración de niveles de acceso para los roles del sistema</p>
                    </div>
                    <div className="mt-3 mt-md-0 d-flex flex-wrap gap-2">
                        <button onClick={() => this.initializeDefaults(false)} className="action-btn-pill btn-pill-light mr-2 mb-2">
                            <i className="fa fa-unlock-alt"></i> Inicializar faltantes
                        </button>
                        <button onClick={() => this.initializeDefaults(true)} className="action-btn-pill btn-pill-light mr-2 mb-2">
                            <i className="fa fa-refresh"></i> Resetear Roles
                        </button>
                    </div>
                </div>

                {/* Filters */}
                <Card className="mb-4 shadow-sm border-0">
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-white border-right-0">
                                            <i className="fa fa-search text-muted"></i>
                                        </span>
                                    </div>
                                    <Input
                                        type="text"
                                        className="form-control border-left-0 pl-0"
                                        placeholder="Buscar por rol o nombre..."
                                        value={headerSearch}
                                        onChange={(e) => this.setState({ headerSearch: e.target.value })}
                                        style={{ boxShadow: 'none' }}
                                    />
                                    {headerSearch && (
                                        <div className="input-group-append">
                                            <Button color="light" className="border-left-0" onClick={() => this.setState({ headerSearch: '' })}>
                                                <i className="fa fa-times text-muted"></i>
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Table */}
                <Card className="shadow-sm border-0">
                    <CardBody className="p-0">
                        {loading ? (
                            <div className="p-4 text-center text-muted">Cargando roles...</div>
                        ) : (
                            <Table responsive hover className="mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="border-top-0 border-bottom-0">Rol ID</th>
                                        <th className="border-top-0 border-bottom-0">Nombre de Rol Principal</th>
                                        <th className="border-top-0 border-bottom-0 text-center">Usuarios Activos</th>
                                        <th className="border-top-0 border-bottom-0 text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredRoles.map(role => (
                                        <tr key={role.id}>
                                            <td className="align-middle font-weight-bold text-muted">  {
        role.system_role
            ? (role.system_role.const_value || role.system_role.id)
            : role.role
    }</td>
                                            <td className="align-middle font-weight-bold text-primary">{
        role.system_role
            ? role.system_role.name
            : (role.role_display || role.name)
    }</td>
                                            <td className="align-middle text-center">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Badge color="primary" pill className="mr-2" style={{ fontSize: '0.85rem' }}>
                                                        {role.global_users_count || role.users_count || 0}
                                                    </Badge>
                                                    <Button
                                                        color="link"
                                                        size="sm"
                                                        className="p-0 text-decoration-none font-weight-bold"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.openUsersModal(role);
                                                        }}
                                                    >
                                                        Ver Usuarios
                                                    </Button>
                                                </div>
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="action-btn-group">
                                                    <Link
                                                        to={`/roles/${role.id}/edit`}
                                                        className="btn-action-edit"
                                                        title="Editar permisos"
                                                    >
                                                        <i className="fa fa-pencil"></i>
                                                    </Link>
                                                    <span className="text-muted small ml-2">Configuración Base</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}

                                    {filteredRoles.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center p-4 text-muted">
                                                No se encontraron roles{headerSearch ? ` coincidiendo con "${headerSearch}"` : ''}.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </CardBody>
                </Card>

                {/* Modal View Users */}
                <Modal isOpen={modalOpen} toggle={this.closeModal} size="lg">
                    <ModalHeader toggle={this.closeModal} className="bg-light">
                        Usuarios con Rol: <strong>{selectedRole ? (selectedRole.name || selectedRole.role_display) : ''}</strong>
                    </ModalHeader>
                    <ModalBody>
                        <Row className="mb-3">
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="text-muted font-weight-bold">Buscar Usuario</Label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-white"><i className="fa fa-search text-muted"></i></span>
                                        </div>
                                        <Input
                                            type="text"
                                            placeholder="Nombre o username..."
                                            value={search}
                                            className="border-left-0"
                                            onChange={(e) => this.handleFilterChange('search', e.target.value)}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="text-muted font-weight-bold">Estado</Label>
                                    <Input
                                        type="select"
                                        value={filterStatus}
                                        onChange={(e) => this.handleFilterChange('filterStatus', e.target.value)}
                                    >
                                        <option value="all">Todos</option>
                                        <option value="true">Activo</option>
                                        <option value="false">Inactivo</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <p className="text-muted small text-right mb-2">Total encontrados: {usersTotal}</p>
                        <Table size="sm" striped hover responsive>
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-top-0 border-bottom-0">ID</th>
                                    <th className="border-top-0 border-bottom-0">Usuario</th>
                                    <th className="border-top-0 border-bottom-0">Nombre Completo</th>
                                    <th className="border-top-0 border-bottom-0 text-center">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {usersLoading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center p-4 text-muted">Cargando usuarios...</td>
                                    </tr>
                                ) : (
                                    <React.Fragment>
                                        {roleUsers.map(user => (
                                            <tr key={user.id}>
                                                <td className="align-middle text-muted">{user.id}</td>
                                                <td className="align-middle font-weight-bold">{user.username}</td>
                                                <td className="align-middle">{user.first_name} {user.last_name}</td>
                                                <td className="align-middle text-center">
                                                    <Badge color={user.status === 5 ? 'success' : 'danger'} pill>
                                                        {user.status === 5 ? 'Activo' : 'Inactivo'}
                                                    </Badge>
                                                </td>
                                            </tr>
                                        ))}
                                        {roleUsers.length === 0 && (
                                            <tr><td colSpan="4" className="text-center p-4 text-muted">No hay usuarios en esta vista.</td></tr>
                                        )}
                                    </React.Fragment>
                                )}
                            </tbody>
                        </Table>

                        {/* Pagination */}
                        {usersTotal > 0 && !usersLoading && (
                            <div className="d-flex justify-content-center mt-3">
                                <Pagination aria-label="Navegación de usuarios">
                                    <PaginationItem disabled={!hasPrevPage}>
                                        <PaginationLink previous onClick={() => this.changePage(usersPage - 1)} />
                                    </PaginationItem>
                                    <PaginationItem active>
                                        <PaginationLink>{usersPage}</PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem disabled={!hasNextPage}>
                                        <PaginationLink next onClick={() => this.changePage(usersPage + 1)} />
                                    </PaginationItem>
                                </Pagination>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter className="bg-light">
                        <Button color="secondary" outline onClick={this.closeModal}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect()(RolesList);
